export default __webpack_public_path__ + "static/coll-womens-health__core-360-paid-06-2ef1af9e160c7ba9dbaee6cfff1727f0.jpg";